<template>
  <div>
    <img @click="clickPlay" :src="music.image" :class="isPlay ? 'rotate-3' : ''" :style="getStyle(music)" />
    <audio id="audio" :src="music.url" autoplay="true" preload="auto" loop="loop">
      <source :src="music.url" type="audio/mpeg" />
    </audio>
  </div>
</template>
<script>
export default {
  name: 'UiPopup',
  components: {
  },
  props: {
    music: {
      type: Object
    }
  },
  data () {
    return {
      isPlay: false,
      musicAudio: null
    }
  },
  computed: {
  },
  watch: {
  },
  methods: {
    clickPlay () {
      if (document.getElementById('audio').paused) {
        document.getElementById('audio').play()
      } else {
        document.getElementById('audio').pause()
      }
      this.doIsPlay()
    },
    doIsPlay () {
      if (document.getElementById('audio').paused) {
        this.isPlay = false
      } else {
        this.isPlay = true
      }
    },
    initMusic () {
      document.getElementById('audio').play()
      this.doIsPlay()
    },
    getStyle (styles) {
      var style = 'position: absolute;'
      style += styles.size_type + ': ' + styles.size_value + ';'
      style += styles.y_axis_type + ': ' + styles.y_axis_value + ';'
      style += styles.x_axis_type + ': ' + styles.x_axis_value + ';'
      return style
    }
  },
  mounted () {
    // this.initMusic()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ui/music.vue